import { useState, useEffect } from 'react'
import { db } from '../firebase'
import {
  collection,
  updateDoc,
  deleteDoc,
  doc,
  query,
  onSnapshot,
  orderBy
} from 'firebase/firestore'
import axios from 'axios'

const NoteScreen = ({ user }) => {
  const [note, setNote] = useState('')
  const [notes, setNotes] = useState([])
  const [editingId, setEditingId] = useState(null)
  const [editingContent, setEditingContent] = useState('')

  useEffect(() => {
    if (!user) return
    const q = query(
      collection(db, 'users', user.uid, 'notes'),
      orderBy('timestamp', 'desc')
    )
    const unsubscribe = onSnapshot(q, (snapshot) => {
      setNotes(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })))
    })
    return unsubscribe
  }, [user])

  const saveNote = async () => {
    if (note.trim() === '') return
    try {
      await axios.post('http://localhost:5000/api/saveNote', {
        uid: user.uid,
        content: note.trim()
      })
      setNote('')
    } catch (error) {
      console.error('Lagring feilet:', error)
      alert('❌ Feil under lagring')
    }
  }

  const deleteNote = async (id) => {
    await deleteDoc(doc(db, 'users', user.uid, 'notes', id))
  }

  const startEditing = (id, content) => {
    setEditingId(id)
    setEditingContent(content)
  }

  const saveEdit = async () => {
    if (editingContent.trim() === '') return
    await updateDoc(doc(db, 'users', user.uid, 'notes', editingId), {
      content: editingContent
    })
    setEditingId(null)
    setEditingContent('')
  }

  if (!user) return <div className="text-red-500">Du er ikke logget inn.</div>

  return (
    <div className="p-4 max-w-xl mx-auto">
      <h1 className="text-2xl font-bold mb-4">Notater</h1>

      <textarea
        value={note}
        onChange={(e) => setNote(e.target.value)}
        placeholder="Skriv ny Note..."
        className="w-full p-2 border rounded bg-white text-black caret-black"
      />
      <button
        onClick={saveNote}
        className="mt-2 bg-black text-white px-4 py-1 rounded"
      >
        Lagre
      </button>

      <div className="mt-6 space-y-4">
        {notes.map(n => (
          <div key={n.id} className="p-3 border rounded bg-gray-50">
            {editingId === n.id ? (
              <>
                <textarea
                  value={editingContent}
                  onChange={e => setEditingContent(e.target.value)}
                  className="w-full p-2 border rounded bg-white text-black caret-black"
                />
                <div className="flex gap-2 mt-2">
                  <button
                    onClick={saveEdit}
                    className="bg-green-600 text-white px-3 py-1 rounded"
                  >
                    Lagre endring
                  </button>
                  <button
                    onClick={() => setEditingId(null)}
                    className="text-sm text-gray-600"
                  >
                    Avbryt
                  </button>
                </div>
              </>
            ) : (
              <>
                <div className="text-black">{n.content}</div>
                <div className="text-xs text-gray-500 mt-1">
                  Lagret: {n.timestamp?.toDate().toLocaleString()}
                </div>
                <div className="flex gap-2 mt-2">
                  <button
                    onClick={() => startEditing(n.id, n.content)}
                    className="text-sm text-blue-600"
                  >
                    Rediger
                  </button>
                  <button
                    onClick={() => deleteNote(n.id)}
                    className="text-sm text-red-600"
                  >
                    Slett
                  </button>
                </div>
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

export default NoteScreen
